module.exports = __webpack_public_path__ + "img/couples-050.ad54c723.jpg";